// Dynamic backend API and Socket URL configuration

const isProd = process.env.NODE_ENV === 'production';

// API base URL: In production, relative '/api' unless overridden
export const API_BASE = 
  process.env.REACT_APP_API_URL || 
  (isProd ? '/api' : 'http://localhost:5000/api');

// Socket server URL: In production, current origin unless overridden
export const SOCKET_URL = 
  process.env.REACT_APP_SOCKET_URL || 
  (isProd ? (typeof window !== 'undefined' ? window.location.origin : '') : 'http://localhost:5000');

// Helper to format upload/image paths
export const getUploadUrl = (imgPath) => {
  if (!imgPath) return '';
  if (imgPath.startsWith('http://') || imgPath.startsWith('https://') || imgPath.startsWith('data:')) {
    return imgPath;
  }
  let clean = imgPath.replace(/^\/+/, '');
  if (!clean.startsWith('uploads/')) {
    clean = `uploads/${clean}`;
  }
  
  if (isProd) {
    return `/${clean}`;
  }
  return `http://localhost:5000/${clean}`;
};

// Helper to format timestamps into date and 12-hour time (IST/locale aware)
export const formatDateTime = (dateStr) => {
  if (!dateStr) return { date: '—', time: '', full: '—' };
  try {
    let cleanStr = String(dateStr).trim();
    const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(cleanStr);
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(cleanStr)) {
      cleanStr = cleanStr.replace(' ', 'T') + 'Z';
    }
    const d = new Date(cleanStr);
    if (isNaN(d.getTime())) return { date: String(dateStr).split('T')[0], time: '', full: String(dateStr) };
    const date = d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    if (isDateOnly) {
      return { date, time: '', full: date };
    }
    const time = d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
    return { date, time, full: `${date}, ${time}` };
  } catch (_) {
    return { date: String(dateStr).split('T')[0], time: '', full: String(dateStr) };
  }
};
